import { Inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, mergeMap, tap } from 'rxjs/operators';
import { PermitRequestUpdateComponent } from '../components/permit-request-update/permit-request-update.component';
import { PermitsMetaDataItemNames, PermitEntity, PermitsMetaDataService, NoteTypeAllItems, PermitStatusAllItems, CodeValueInspectionResults, CodeValueInspectionState, RoInspectionsEntity } from '../meta-data/permits-meta-data.service';
import { NotesRepositoryService } from '../../../shared/notes/services/notes-repository-service';
import {
  DwMetaDataRoutingService, DwMetaDataGridActionState, DwActionResult, DwMenuActionType,
  DwAction, DwActionType,
  DwGridActionResult,
  DwMdFormActionResult, DwMdFormActionHandler,
  DwMdFormActionState, DwQueryHelper,
  DwModalButtonStandardConfigs, DwModalConfig,
  DwModalService, DwModalSize, DwOrmDataService, DwOrmDataServiceToken
} from '@devwareapps/devware-cap';

@DwAction({
  keyName: 'Permits_Inspection_Needed',
  display: 'Permits - Inspection Needed',
  actionType: DwActionType.formAction,
  isGlobal: true,
  parentItemName: [PermitsMetaDataItemNames.Permit, PermitsMetaDataItemNames.Inspection],
  defaultButtonConfig: {
    buttonClass: 'btn-sm btn-success mr-1 mt-1',
    buttonText: 'Request Inspection'
  },
  defaultSecurityConfig: {
    requireCanUpdate: false
  },
})
@Injectable()
export class PermitRequestInspectionActionService implements DwMdFormActionHandler {

  constructor(
    private metaDataRoutingService: DwMetaDataRoutingService,
    private dwModalService: DwModalService,
    private notesRepository: NotesRepositoryService,
    @Inject(DwOrmDataServiceToken) private dataService: DwOrmDataService
  ) { }

  handleAction(formActionState: DwMdFormActionState): Observable<DwActionResult> {
    const permitEntity: PermitEntity = formActionState.formApi.getFormData()
    const id: number = formActionState.data.InspectionId;
    
    const action: DwMenuActionType = id ? DwMenuActionType.edit : DwMenuActionType.add;
    
    const isAdd = (action == DwMenuActionType.add);

    const modalOptions : Partial<DwModalConfig> = {
      modalSize : DwModalSize.responsive,
      title: isAdd ? 'Request Inspection' : 'Edit Inspection'
    };

    return this.metaDataRoutingService.openAddEditViewModal(action, PermitsMetaDataItemNames.Inspection, id, { permitId: permitEntity.PermitId }, null, null, modalOptions)
      .pipe(map(modalResult => {
        const msg = isAdd ? (modalResult.cancelled ? "No inspection requested." : "Inspection request has been made.") 
                          : (modalResult.cancelled ? "No changes made to inspection." : "Inspection updated successfully.");
        const actionResult: DwMdFormActionResult = { success: !isAdd || !modalResult.cancelled, message: msg };
        if (actionResult.success)
          this.getPermitWithInspections(permitEntity.PermitId).subscribe(changes => {
            const update = {
              RoInspections: changes.RoInspections,
              InspectionStateCvDisplay: changes.InspectionStateCvDisplay
            };
            formActionState.formApi.patchFormData(update);
          });
        return actionResult;
      }));
  }
  getPermitWithInspections(permitId): Observable<PermitEntity> {
    const md = new PermitsMetaDataService();
    const qh = new DwQueryHelper();
    const query = md.Permit.CreateQuery()
      .AddFilterAnd(qh.filters.Equal(md.Permit.PermitId, permitId))
      .AddPrefetchPath(md.Permit.Relations.RoInspections);
    query.FieldSettings.LoadAllLookupDisplayFields = true;
    return this.dataService.executeQuerySingle(query);
  }
}
